import React from 'react';

interface Props {
  address: string;
}

const BroadbandAddress = ({ address }: Props) => {
  return (
    <div className="pt-4 pb-4 w-full">
      <label className="block mb-2 sky-h4-bold">We have your address as</label>
      <div className="sky-h4-bold mb-2">{address}</div>
      <div className="sky-h4-bold">Please ensure the address we have on our system is correct</div>
    </div>
  );
};

export { BroadbandAddress };
